import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "style", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from '@jd/jmtd-tools/es/classnames';
import { isNumber } from '@jd/jmtd-tools/es/is';
import ConfigConsumer from '../ConfigConsumer';
var sizeSet = new Set(['mini', 'small', 'middle', 'large']);
export default function Icon(_ref) {
  var className = _ref.className,
      style = _ref.style,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ConfigConsumer, {
    size: size
  }, function (_ref2) {
    var configSize = _ref2.size;
    // 处理自定义尺寸，诸如20或者'20px'
    var styleBySize = {};
    var customSize = false;

    if (isNumber(configSize) || size && !sizeSet.has(configSize)) {
      styleBySize = {
        fontSize: configSize
      };
      customSize = true;
    }

    return /*#__PURE__*/React.createElement("span", _extends({
      className: classNames(className, 'jmtd-icon', 'jmtd-icon-font', {
        'jmtd-icon-custom-size': customSize,
        'jmtd-icon-mini': configSize === 'mini',
        'jmtd-icon-small': configSize === 'small',
        'jmtd-icon-large': configSize === 'large'
      }),
      style: _objectSpread(_objectSpread({}, styleBySize), style)
    }, props));
  });
}
Icon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.oneOf(['mini', 'large', 'small', 'middle'])])
};
Icon.defaultProps = {
  className: '',
  style: {},
  size: null
};